import type {ConnectElementConfig} from '../../../connect/ConnectJSInterface/ConnectElementList';
import {ComponentOverrideFlag} from '../../../utils/flags/flags';

export const FinancialAccountsConfig: ConnectElementConfig = {
  Component: () =>
    import(
      /* webpackChunkName: "FinancialAccounts" */
      '../../../components/MoneyManagement/FinancialAccounts'
    ),
  releaseState: 'internal',
  enabledKey: 'financial_accounts',
  enabledOverrideFlag: ComponentOverrideFlag.financial_accounts,
  teamOwner: 'platform-surfaces',
  sentryTeam: 'platform_surfaces_embedded',
  description: 'Displays a list of financial accounts.',
  friendlyName: 'Financial accounts',
  enableV2APIToken: true,
};
